












































// an example of a Vue Typescript component using Vue.extend
import Vue from 'vue';
import { Forecast } from '../models/Forecast';
import axios from 'axios';

export default Vue.extend({
  data() {
    return {
      loading: true,
      showError: false,
      errorMessage: 'Error while loading weather forecast.',
      forecasts: [] as Forecast[],
      headers: [
        { text: 'Date', value: 'date' },
        { text: 'Temp. (C)', value: 'temperatureC' },
        { text: 'Temp. (F)', value: 'temperatureF' },
        { text: 'Summary', value: 'summary' },
      ],
    };
  },
  methods: {
    getColor(temperature: number) {
      if (temperature < 0) {
        return 'blue';
      } else if (temperature >= 0 && temperature < 30) {
        return 'green';
      } else {
        return 'red';
      }
    },
    async fetchWeatherForecasts() {
      try {
        const response = await axios.get<Forecast[]>('api/WeatherForecast');
        this.forecasts = response.data;
      } catch (e) {
        this.showError = true;
        this.errorMessage = `Error while loading weather forecast: ${e.message}.`;
      }
      this.loading = false;
    },
  },
  async created() {
    await this.fetchWeatherForecasts();
  },
});
